import { getSnowBearerToken } from "./localstorage";
import { localStorageHackedKeyForKidEmail } from "@me8eon/react_authentication";

export function getKID(): string {
    return getKidFromEmail(getKIDEmail())
}
export function getKidFromEmail(email: string): string {
    const emailParts = email.split("@");
    return emailParts[0] || "";
}

export function getKIDEmail(): string {
    const email = localStorage.getItem(localStorageHackedKeyForKidEmail);
    return email || "";
}

export function getAuthHeader() {
    return {
        kid: getKID(),
        Authorization: `Bearer ${getSnowBearerToken()}`,
        "Content-Type": "application/json",
    };
}

